import PropTypes from 'prop-types'

import Loading from 'components/loading/Loading'

const LoadingWrapper = ({ isLoading, inline, size, children }) => {
  const Tag = inline ? 'span' : 'div'
  return (
    <Tag
      style={{ position: 'relative', ...(isLoading ? { opacity: 0.5 } : {}) }}>
      {children}
      {isLoading && (
        <Tag
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}>
          <Loading size={size} />
        </Tag>
      )}
    </Tag>
  )
}

LoadingWrapper.propTypes = {
  size: PropTypes.oneOf(['big', 'small', 'icon']),
  inline: PropTypes.bool,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default LoadingWrapper
